import { CustomInputLabel } from '../../../../../components/CustomInputLabel';
import { FormRow } from '../../../../../components/Form/FormRow';
import { PlainTextWithReplacementPlaceholders } from '../../../../../components/MarkdownText';
import { TextFieldWithReplacementTokens } from '../../../../../components/TextFieldWithReplacementTokens';
import { useUnsafeTranslation } from '../../../../../i18next';
import { EditComponentProps, ViewComponentProps } from '../types';

export const EditSectionSubject = ({
  value,
  onChange,
  tokens
}: EditComponentProps) => {
  const { t } = useUnsafeTranslation();
  return (
    <FormRow>
      <CustomInputLabel label={t('Subject')} fullWidth>
        <TextFieldWithReplacementTokens
          value={value.data.subject}
          onChange={(v) =>
            onChange({
              ...value,
              data: {
                ...value.data,
                subject: v
              }
            })
          }
          fullWidth
          variant="outlined"
          tokens={tokens}
        />
      </CustomInputLabel>
    </FormRow>
  );
};

export const ViewSectionSubject = ({ value, tokens }: ViewComponentProps) => {
  return (
    <PlainTextWithReplacementPlaceholders
      text={value.data.subject}
      tokens={tokens}
    />
  );
};
